module.exports = __webpack_public_path__ + "static/wages-1-b10e6e7ef8de41a762b30f247828c88c.png";